import React, { useState } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import { formatDateLong } from "../../../../../utils/textUtils";

const EmployeeTypeTaggingTable = ({ data, onView }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const headers = ["Trans #", "Employee ID", "Full Name", "Temp. Employee Type", "Effectivity", "Actions"];
  const accessors = ["transactionNumber", "employeeId", "employeeFullName", "employeeType", "effectivityDate", "actions"];

  const actions = [
    {
      tooltip: "View Details",
      icon: <VisibilityIcon fontSize="small" />,
      color: "bg-blue-600",
      visible: true,
      function: (row) => onView(row),
    }
  ];

  const customCellRenderer = (row, accessor) => {
    if (accessor === "effectivityDate") return <span>{formatDateLong(row[accessor])}</span>;
    if (accessor === "transactionNumber") return <span className="font-bold text-blue-800">{row[accessor]}</span>;
    return null;
  };

  return (
    <CreateTable
      tableName="EmployeeTypeTaggingTable"
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data.length}
      customCellRenderer={customCellRenderer}
    />
  );
};

export default EmployeeTypeTaggingTable;